// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"5d63cb84","256":"bc982c7c","351":"4a96eb2c","952":"723dc16b"}[chunkId] + ".chunk.js";
};